import type { ErrorInfo } from 'react'

import { captureError } from '@libs/sentry/sentry'

type ReactErrorKind = 'uncaught' | 'caught' | 'recoverable'

export function reportReactError(kind: ReactErrorKind, error: unknown, info: ErrorInfo): void {
  const message = error instanceof Error ? error.message : String(error)
  const componentStack = info.componentStack ?? undefined

  console.error(`[react:${kind}]`, error, componentStack)

  window.clarity?.('event', 'react_error', { kind, message, componentStack })
  captureError(error, { extra: { kind, componentStack } })
}
